import React from 'react'

import './Spacer.css'

const Spacer = () => {
  return <div className="fmbm-spacer" />
}

export default Spacer



// WEBPACK FOOTER //
// ./src/Components/Spacer/Spacer.js